import React from 'react' // useState
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import PlayCircle from '@mui/icons-material/PlayCircle'
import PauseCircle from '@mui/icons-material/PauseCircle'
import Alert from '@mui/material/Alert'
import {
  AlertWrapper,
  // ChargeRow,
  // ChargeSelect,
  // ChargeWrapper
} from './styles'
import { useNotify, useRedirect } from 'react-admin'
import API from '../../services/api'
import moment from 'moment'

const OutlinedCard = (props: any) => {
  const notify = useNotify()
  const redirect = useRedirect()

  // const [months, setMonths] = useState(1)

  const startStopBot = async (method: string) => {
    try {
      await API.put(`/bots/${props.botId}/${method}`)

      notify('Bot iniciado com sucesso', { type: 'success' })

      props.loadBots()
    } catch (error: any) {
      if (error.response.data.status === 409) {
        props.loadBots()
      } else if (error.response.data.status === 402) {
        notify('O bot está expirado, realize o pagamento para voltar a utilizar.', {
          type: 'error',
        })
      } else {
        notify('Ocorreu um erro, tente novamente.', { type: 'error' })
      }
    }
  }

  // const createCharge = async (botId: number) => {
  //   try {
  //     const response = await API.post('/charges', {
  //       months: +months,
  //       botId: botId,
  //     })

  //     window.open(response.data.charge.init_point, '_blank')
  //     redirect('/charges')
  //   } catch (error) {
  //     notify('Ocorreu um erro, tente novamente.', {
  //       type: 'error',
  //     })
  //   }
  // }

  const expired = moment(props.expiresAt).isBefore(moment())

  return (
    <Box sx={{ minWidth: 275 }}>
      <Card variant="outlined">
        <React.Fragment>
          <CardContent>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography variant="h5" component="div">
                {props.title}
              </Typography>
              <div>
                <Button
                  sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
                  variant="contained"
                  disabled={!props.status}
                  onClick={() => {
                    redirect(`/bot_adm/${props.botId}`)
                  }}
                >
                  Administrar
                </Button>
                <Button
                  sx={{
                    'marginLeft': '10px',
                    'backgroundColor': '#00A76F',
                    '&:hover': { backgroundColor: '#00A76F' },
                  }}
                  variant="contained"
                  disabled={props.status}
                  endIcon={<PlayCircle />}
                  onClick={() => {
                    startStopBot('start')
                  }}
                >
                  Ligar
                </Button>
                <Button
                  sx={{
                    'marginLeft': '10px',
                    'backgroundColor': '#B71D18',
                    '&:hover': { backgroundColor: '#B71D18' },
                  }}
                  variant="contained"
                  disabled={!props.status}
                  endIcon={<PauseCircle />}
                  onClick={() => {
                    startStopBot('stop')
                  }}
                >
                  Desligar
                </Button>
              </div>
            </div>
            <AlertWrapper>
              <Alert severity={expired ? 'error' : 'warning'}>
                {expired
                  ? 'O seu bot expirou, faça o pagamento para continuar utilizando.'
                  : `O seu bot ira expirar em: ${moment(props.expiresAt).diff(
                      moment(),
                      'days'
                    )} dias e ${moment(props.expiresAt).diff(moment(), 'hours') % 24} horas`}
              </Alert>
            </AlertWrapper>
            <AlertWrapper>
              <Alert severity={props.status ? 'success' : 'warning'}>
                {props.status ? 'O bot está ligado' : 'O bot está desligado'}
              </Alert>
            </AlertWrapper>
            {/* <ChargeWrapper>
              <span>Licenciar por mais</span>

              <ChargeRow>
                <ChargeSelect
                  value={months}
                  onChange={(ev: any) => {
                    setMonths(ev.target.value)
                  }}
                >
                  <option value={1}>1 Mês R$ 99.00</option>
                  <option value={3}>3 Meses (- 2,5%) R$ 289.58</option>
                  <option value={6}>6 Meses (- 5%) R$ 564.30</option>
                  <option value={12}>12 Meses (- 10%) R$ 1069.20</option>
                  <option value={24}>24 Meses (- 20%) R$ 1900.80</option>
                </ChargeSelect>

                <Button
                  sx={{
                    'marginTop': '10px',
                    'backgroundColor': '#00A76F',
                    '&:hover': { backgroundColor: '#00A76F' },
                  }}
                  variant="contained"
                  title="Lançar Cobranca"
                  onClick={() => {
                    createCharge(props.botId)
                  }}
                >
                  Lançar Cobranca
                </Button>
              </ChargeRow>
            </ChargeWrapper> */}
          </CardContent>
        </React.Fragment>
      </Card>
    </Box>
  )
}

export default OutlinedCard
